// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)

Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  if (to.query.respData) {
    next()
    return
  }
  if (from.query.respData) {
    const toQuery = JSON.parse(JSON.stringify(to.query))
    toQuery.respData = from.query.respData
    next({
      path: to.path,
      query: toQuery
    })
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js